export enum AddStaffPageNumber {
    manualAddStaffPage = 1,
    csvUploadAddStaffPage = 2,
    fileUploadPage = 3
  }